import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';
import useQueryParams from 'hooks/useQueryParams';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import TemplateModal from './TemplateModal';

const CreateModal = ({ onClose }) => {
  const query = useQueryParams();
  const [selected, setSelected] = useState('');
  const [showTemplateModal, setShowTemplateModal] = useState(
    query.type === 'template',
  );
  const history = useHistory();

  const onNext = () => {
    if (selected === 'custom') {
      history.push(`/connect/cards/create?group_id=${query.group_id || ''}`);
    } else {
      setShowTemplateModal(true);
    }
  };

  if (showTemplateModal) {
    return <TemplateModal onClose={() => setShowTemplateModal(false)} />;
  }

  return (
    <Modal
      open
      fullWidth
      maxWidth="sm"
      onClose={onClose}
      actions={[
        <Button disabled={!selected} onClick={onNext}>
          Next
        </Button>,
      ]}
    >
      <Box mb={3} mt={2}>
        <Typography gutterBottom variant="h4" fontWeight={600}>
          Use a template or create from scratch
        </Typography>
        <Typography color="text.secondary">
          Create your Connect Card using one of our templates or create your own
          workflow from scratch.
        </Typography>
      </Box>
      <Stack direction="row" spacing={2}>
        <Paper
          variant="outlined"
          sx={{
            p: 3,
            mb: 2,
            bgcolor: selected === 'template' && 'primary.lighter',
            borderColor: selected === 'template' && 'primary.main',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
          onClick={() => setSelected('template')}
        >
          <Stack direction="row" spacing={1} mb={1} alignItems="center">
            <Typography fontWeight={600} variant="subtitle1">
              Create from Template
            </Typography>
          </Stack>
          <Typography paragraph color="text.secondary">
            Get your connect card easily set up by selecting one of our
            predesigned templates.
          </Typography>
          <Chip label="Recommended" size="small" color="warning" />
        </Paper>
        <Paper
          variant="outlined"
          sx={{
            p: 3,
            cursor: 'pointer',
            bgcolor: selected === 'custom' && 'primary.lighter',
            borderColor: selected === 'custom' && 'primary.main',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
          mb={2}
          onClick={() => setSelected('custom')}
        >
          <Typography gutterBottom fontWeight={600} variant="subtitle1">
            Create from scratch
          </Typography>
          <Typography color="text.secondary">
            Build a connect card from scratch. Add questions to build your own
            custom flow.
          </Typography>
        </Paper>
      </Stack>
    </Modal>
  );
};

export default CreateModal;
